import React, { useState } from "react";
import AuthService from "../features/auth/auth.service";

import './Profile.scss';



import { Button, Modal } from 'react-bootstrap'

import PasswordChecklist from "react-password-checklist"


import Dialog from '../services/Dialogs'

import { toast } from 'react-toastify'


import RequestService from "../services/request.service";
import { labelPrivilegio } from "../services/funcionesPublicas";


// import { Navigate } from 'react-router-dom';

// export default class Profile extends Component {
const Profile = () => {


    const [password, setPassword] = useState("")
    const [passwordAgain, setPasswordAgain] = useState("")

    const dialog = new Dialog();

    const VERSION_INSTALADA = localStorage.getItem("version_app");
    // const VERSION_ACTUAL = localStorage.getItem("version_app");



      const [ VERSION_ACTUAL, serVersionActual ] = useState<string>('')

      const cargarVersionActual = async () =>{
        try{
            let res = await RequestService.getEndPoint('version_app')
            serVersionActual(res.data)

        }
        catch(e){
          toast.error('Problemas cargando la versión actual')
          toast.error(JSON.stringify(e))
        }
      }

      React.useEffect(() => {
        cargarVersionActual()
      }, []);




  const handleLogout = async () => {
    if(await dialog.confirm('¿Estás seguro que quieres salir?',{}) ){
        AuthService.logout();
        window.location.reload();
    }
  }

    const FormateaNumero = (n:string) => n.substr(0,3) + '-' + n.substr(3,3) + '-' + n.substr(6,4) 

    const currentUser  = AuthService.getCurrentUser();
    // const accessToken = AuthService.getToken()
    const [show, setShow] = useState(false);
    const [send, setSend] = useState(false);

  const handleClose = () => setShow(false);
  const cambiarContrasenaModal = () =>{ 
      setPassword("")
      setPasswordAgain("")
      setShow(true);
  }
  
  const cambiarContrasena = async () =>{ 
      
      try{
          if(await dialog.confirm('¿Estás seguro que quieres cambiar tu contraseña?',{}) ){
              setShow(false);
              await RequestService.update('usuario/'+currentUser.uuid,{ psw : password })
              toast.warning('Debes volver a entrar al sistema')
              setTimeout(()=>{
                  AuthService.logout();
                  window.location.reload();
              },1500)
          }
      }
      catch(e){
          toast.error('Error al cambiar la contraseña')
      }
  }




  const deleteCache = async ()=>{
    
          if(await dialog.confirm('¿Estás seguro?',{}) ){
                  localStorage.clear();
                  window.location.reload();
          }
  }
      return (

        <React.Fragment>
          


<div className="container">
<div className="row">
    <div className="col-lg-6 col-xl-6">
        <div className="card-box text-center">
        {
            // <img src="https://bootdey.com/img/Content/avatar/avatar7.png" className="rounded-circle avatar-xl img-thumbnail" alt="profile-image" />
        }

            <h4 className="mb-0">{currentUser.username}</h4>
            <p className="text-muted">
              <small>{currentUser.uuid}</small>
            </p>


            <div className="text-left mt-3 mb-3">

                <h6>Información de Usuario</h6>


                    <div className="row">
                      <div className="col-md-2">

                <div className="quiz-medal">
                  <div className={'quiz-medal__circle quiz-medal__circle--'+currentUser.rol+''}>
                  </div>
                  <div className="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
                  <div className="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
                </div>

                        
                      </div>
                      <div className="col">
                        
                <p className="text-muted mb-2 font-13"><strong>Nombre : </strong> <span className="ml-2">{currentUser.nombres} {currentUser.paterno} {currentUser.materno}</span></p>

                <p className="text-muted mb-2 font-13"><strong>Celular : </strong><span className="ml-2">{FormateaNumero(currentUser.celular)}</span></p>

                <p className="text-muted mb-2 font-13"><strong>Email : </strong> <span className="ml-2 ">{currentUser.email}</span></p>

                {
                  currentUser.idsucursal && (
                      <p className="text-muted mb-1 font-13"><strong>Sucursal : </strong> <span className="ml-2">{currentUser.idsucursal.nombre_sucursal}</span></p>
                  )
                }



                <p className="text-muted mb-2 font-13"><strong>Privilegios : </strong> <span className="ml-2 ">{labelPrivilegio(currentUser.rol)}</span></p>


                <p className="text-muted mb-2 font-13"><strong>Versión Instalada : </strong> <span className="ml-2 ">{VERSION_INSTALADA||`No podemos verificar la versión instalada `}</span></p>
                <p className="text-muted mb-2 font-13"><strong>Versión Actual : </strong> <span className="ml-2 ">{VERSION_ACTUAL}</span></p>


                      </div>
                    </div>


                {
                  // labelPrivilegio(currentUser.rol)
                }


                {
                  // JSON.stringify(currentUser.rol)
                }

 




                
            </div>

            {
              // JSON.stringify(currentUser)
            }




                              <p className="nm mt-4"><small>Opciones</small></p>
                              <ul className="list-inline">
                                  <li className="list-inline-item" key={ Math.random().toString(36).substr(2, 9) }>
                                    <button onClick={()=>{cambiarContrasenaModal()}} className="btn btn-link">Cambiar Contraseña</button>
                                  </li>
                                  <li className="list-inline-item" key={ Math.random().toString(36).substr(2, 9) }>
                                    <button onClick={()=>{handleLogout()}} className="btn btn-link">Salir</button>
                                  </li>
                                  <li className="list-inline-item" key={ Math.random().toString(36).substr(2, 9) }>
                                    <button onClick={()=>{deleteCache()}} className="btn btn-link">Borrar Caché</button>
                                  </li>
                              </ul>

                      
        </div> 

 

    </div> 

    <div className="col-lg-8 col-xl-8">
        <div className="card-box-">
 
            
                


                            {
                              // JSON.stringify(currentUser)
                            }

{
                    // <h5 className="mb-4 text-uppercase"><i className="mdi mdi-briefcase mr-1"></i>
                    //     Últimas Noticias</h5>

                    // <ul className="list-unstyled timeline-sm">
                    //     <li className="timeline-sm-item">
                    //         <span className="timeline-sm-date">2015 - 19</span>
                    //         <h5 className="mt-0 mb-1">Lead designer / Developer</h5>
                    //         <p>websitename.com</p>
                    //         <p className="text-muted mt-2">Everyone realizes why a new common language
                    //             would be desirable: one could refuse to pay expensive translators.
                    //             To achieve this, it would be necessary to have uniform grammar,
                    //             pronunciation and more common words.</p>

                    //     </li>
                    //     <li className="timeline-sm-item">
                    //         <span className="timeline-sm-date">2012 - 15</span>
                    //         <h5 className="mt-0 mb-1">Senior Graphic Designer</h5>
                    //         <p>Software Inc.</p>
                    //         <p className="text-muted mt-2">If several languages coalesce, the grammar
                    //             of the resulting language is more simple and regular than that of
                    //             the individual languages. The new common language will be more
                    //             simple and regular than the existing European languages.</p>
                    //     </li>
                    //     <li className="timeline-sm-item">
                    //         <span className="timeline-sm-date">2010 - 12</span>
                    //         <h5 className="mt-0 mb-1">Graphic Designer</h5>
                    //         <p>Coderthemes LLP</p>
                    //         <p className="text-muted mt-2 mb-0">The European languages are members of
                    //             the same family. Their separate existence is a myth. For science
                    //             music sport etc, Europe uses the same vocabulary. The languages
                    //             only differ in their grammar their pronunciation.</p>
                    //     </li>
                    // </ul>

                    // <h5 className="mb-3 mt-4 text-uppercase"><i className="mdi mdi-cards-variant mr-1"></i>
                    //     Projects</h5>
                    // <div className="table-responsive">
                    //     <table className="table table-borderless mb-0">
                    //         <thead className="thead-light">
                    //             <tr>
                    //                 <th>#</th>
                    //                 <th>Project Name</th>
                    //                 <th>Start Date</th>
                    //                 <th>Due Date</th>
                    //                 <th>Status</th>
                    //                 <th>Clients</th>
                    //             </tr>
                    //         </thead>
                    //         <tbody>
                    //             <tr>
                    //                 <td>1</td>
                    //                 <td>App design and development</td>
                    //                 <td>01/01/2015</td>
                    //                 <td>10/15/2018</td>
                    //                 <td><span className="badge badge-info">Work in Progress</span></td>
                    //                 <td>Halette Boivin</td>
                    //             </tr>
                    //             <tr>
                    //                 <td>2</td>
                    //                 <td>Coffee detail page - Main Page</td>
                    //                 <td>21/07/2016</td>
                    //                 <td>12/05/2018</td>
                    //                 <td><span className="badge badge-success">Pending</span></td>
                    //                 <td>Durandana Jolicoeur</td>
                    //             </tr>
                    //             <tr>
                    //                 <td>3</td>
                    //                 <td>Poster illustation design</td>
                    //                 <td>18/03/2018</td>
                    //                 <td>28/09/2018</td>
                    //                 <td><span className="badge badge-pink">Done</span></td>
                    //                 <td>Lucas Sabourin</td>
                    //             </tr>
                    //             <tr>
                    //                 <td>4</td>
                    //                 <td>Drinking bottle graphics</td>
                    //                 <td>02/10/2017</td>
                    //                 <td>07/05/2018</td>
                    //                 <td><span className="badge badge-purple">Work in Progress</span></td>
                    //                 <td>Donatien Brunelle</td>
                    //             </tr>
                    //             <tr>
                    //                 <td>5</td>
                    //                 <td>Landing page design - Home</td>
                    //                 <td>17/01/2017</td>
                    //                 <td>25/05/2021</td>
                    //                 <td><span className="badge badge-warning">Coming soon</span></td>
                    //                 <td>Karel Auberjo</td>
                    //             </tr>

                    //         </tbody>
                    //     </table>
                    // </div>

                

}



        </div> 

    </div> 
</div>
</div>




      <Modal show={show} backdrop="static" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar de Contraseña</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            


        <form>

            <div className="form-group mb-3">
                <label className="form-label">Password:</label>
                <input className="form-control" type="password" onChange={e => setPassword(e.target.value)} />
            </div>
            <div className="form-group mb-3">
                <label className="form-label">Repetir Password:</label>
                <input className="form-control" type="password" onChange={e => setPasswordAgain(e.target.value)} />
            </div>


            <PasswordChecklist
                rules={["minLength","specialChar","number","capital","match"]}
                messages={{
                    minLength: "La contraseña tiene más de 8 carácteres.",
                    specialChar: "La contraseña debe contener carácteres especiales.",
                    number: "La contraseña debe tener un número.",
                    capital: "La contraseña debe tener una letra mayúscula.",
                    match: "Las contraseñas coinciden.",
                }}
                minLength={5}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => {
                    setSend(!isValid)
                }}
            />
        </form>

{
  // password
}

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" disabled={send} onClick={cambiarContrasena}>
            Guardar Cambios
          </Button>
        </Modal.Footer>
      </Modal>





        </React.Fragment>




      );
    
}

export default Profile
